import { AADetectionResults, SoftwallRecoveredType } from "../types";
import { deleteRenderData } from "./render";

const BT_AM_SOFTWALL_RECOVERED = "BT_AM_SOFTWALL_RECOVERED";

export const hasRecoveryData = () =>
  localStorage.getItem(BT_AM_SOFTWALL_RECOVERED) !== null;

export function getRecoveryType(
  aaDetectionResults: AADetectionResults,
  recovered: boolean,
): SoftwallRecoveredType | undefined {
  const latestRecoveryState = getRecoveryData(); // Get the stored recovery state

  let currentRecoveryState: SoftwallRecoveredType | undefined;
  if (recovered) {
    if (!aaDetectionResults.ab) {
      currentRecoveryState = "AB";
    } else if (aaDetectionResults.acceptable) {
      currentRecoveryState = "AA";
    }
  }

  // If the previous recovery state exists but the current one is undefined,
  // it means recovery is no longer valid.
  if (latestRecoveryState && currentRecoveryState === undefined) {
    deleteRenderData(); // Invalidate previous render data
  }

  // If there's no previous recovery state and the user isn't recovered, return undefined
  if (!latestRecoveryState && !recovered) return undefined;

  return currentRecoveryState;
}

function getRecoveryData(): SoftwallRecoveredType {
  // if window.__bt_intrnl.recoveryUserAttr defined it means that
  // bt_tag or bt_am already tried to restore server side user attribution in current page view,
  // so the recovery type value could be getting from the window object;
  if (window.__bt_intrnl.recoveryUserAttr) {
    return window.__bt_intrnl.recoveryUserAttr.recoveryType;
  }
  return (
    (localStorage.getItem(BT_AM_SOFTWALL_RECOVERED) as SoftwallRecoveredType) ||
    undefined
  );
}

export const saveRecovery = (recoveredData: SoftwallRecoveredType) =>
  localStorage.setItem(BT_AM_SOFTWALL_RECOVERED, recoveredData);

export const deleteRecoveryData = () =>
  localStorage.removeItem(BT_AM_SOFTWALL_RECOVERED);
